//环境域名配置文件

const objconfig = {
    devHttpUrl: "http://jyl.bbs.360.cn",
    buildHttpUrl: "bbs.360.cn"
};
export default objconfig;


// WEBPACK FOOTER //
// ./src/api/config.js